module.exports = __webpack_public_path__ + "img/icon-coin.ef250905.png";